// @flow
import { httpClient } from 'angieslist-app-platform';

const ONE_PLATFORM_CONTACTS_URL = 'https://www.angi.com/service-pro/my-proposals/contacts';
const ONE_PLATFORM_NEW_SERVICE_REQUESTS_URL = 'https://www.angi.com/service-pro/new-service-requests';

const LEADS_INBOX_PATH = /^\/app\/h\/inbox\//;

function fallbackOnePlatformRedirectUrl(pagePath: string): string {
  if (LEADS_INBOX_PATH.test(pagePath || '')) return ONE_PLATFORM_CONTACTS_URL;
  return ONE_PLATFORM_NEW_SERVICE_REQUESTS_URL;
}

function allowedOnePlatformRedirectUrl(redirectUrl: mixed): ?string {
  if (typeof redirectUrl !== 'string') return null;
  try {
    const parsed = new URL(redirectUrl.trim());
    if (parsed.protocol !== 'https:') return null;
    const host = parsed.hostname.toLowerCase();
    if (host === 'angi.com' || host.endsWith('.angi.com')) return parsed.toString();
    return null;
  } catch (_err) {
    return null;
  }
}

const getOnePlatformRedirect = (
  serviceProviderId: string,
  pagePath: string,
): Promise<?string> => httpClient.get(
  `/gateway/office-home/v1/one_platform_redirect/${encodeURIComponent(serviceProviderId)}`,
  {
    params: { path: pagePath },
    headers: {
      'X-ANGI-CallerType': 'ServiceProvider',
      'X-ANGI-CallerId': serviceProviderId,
    },
  },
).then((response) => {
  const body = response && (response.body || response);
  if (!body || body.shouldRedirectProToOnePlatform !== true) return null;
  return allowedOnePlatformRedirectUrl(body.redirectUrl)
    || fallbackOnePlatformRedirectUrl(pagePath);
}).catch(() => null);

export default {
  getOnePlatformRedirect,
};



// WEBPACK FOOTER //
// ./src/modules/common/onePlatformRedirectService.js